export default __webpack_public_path__ + "static/media/nemesysco.e3e96f08.jpg";